// Copyright (c) 2017 Deere & Company

import amountDebit from './calculate-percentage';
import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import debit from './debit';
import isConfirmationModalVisible from './confirmation-modal';
import isPercentageDebitModalVisible from './percentage-debit-modal';

export const getCombinedReducers = () => combineReducers({
    amountDebit,
    busyCounter,
    debit,
    isConfirmationModalVisible,
    isPercentageDebitModalVisible
});



// WEBPACK FOOTER //
// ./src/tcsm/percentage-debit/reducers/index.js